import React from 'react';
import { SitePage } from '../site/site-page';
import { HomepageHero } from './homepage-hero';
import { HomepageDemo } from './homepage-demo';
import { HomepageDivider } from './homepage-divider';
import { HomepageIntro } from './homepage-intro';
import { HomepageAudience } from './homepage-audience';
import { HomepageHowItWorks } from './homepage-how-it-works';
import { HomepageFeatureNotes } from './homepage-feature-notes';

export const Homepage = () => (
  <SitePage header={<HomepageHero />} mainId="more">
    <HomepageDemo />
    <HomepageDivider />
    <HomepageIntro />
    <HomepageDivider />
    <HomepageAudience />
    <HomepageDivider />
    <HomepageHowItWorks />
    <HomepageDivider />
    <HomepageFeatureNotes />
  </SitePage>
);
